// Gallery controls only. Shopify/Horizon owns variants, prices, forms and cart.
(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cm-buy]')) {
      const primary = document.querySelector('.cm-product .add-to-cart-button');
      if (primary && !primary.disabled) primary.click();
    }
    const button = event.target.closest('[data-cm-view]');
    if (button) {
      const gallery = button.closest('.cm-gallery');
      const track = gallery.querySelector('.cm-gallery-track');
      track.scrollTo({left: Number(button.dataset.cmView) * track.clientWidth, behavior: reduced() ? 'instant' : 'smooth'});
    }
    const colorLink = event.target.closest('[data-cm-color]');
    if (colorLink) {
      const picker = document.querySelector('.cm-product variant-picker');
      const radio = [...(picker?.querySelectorAll('input[type="radio"]') || [])].find(input => input.value.toLowerCase() === colorLink.dataset.cmColor);
      if (radio) {
        radio.click();
        document.querySelector('.cm-purchase')?.scrollIntoView({behavior: reduced() ? 'instant' : 'smooth', block:'center'});
        radio.focus({preventScroll:true});
        event.preventDefault();
      }
    }
  });
  document.addEventListener('scroll', event => {
    if (!event.target.matches?.('.cm-gallery-track')) return;
    const track = event.target;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    track.closest('.cm-gallery').querySelectorAll('[data-cm-view]').forEach((button,i) => button.setAttribute('aria-pressed', String(i === index)));
    const active = track.closest('.cm-gallery').querySelector(`[data-cm-view="${index}"]`);
    const strip = active?.parentElement;
    if (active && strip) {
      const item = active.getBoundingClientRect(), bounds = strip.getBoundingClientRect();
      if (item.left < bounds.left) strip.scrollLeft -= bounds.left - item.left;
      else if (item.right > bounds.right) strip.scrollLeft += item.right - bounds.right;
    }
  }, true);
  document.addEventListener('keydown',event => {
    if (!event.target.matches('.cm-gallery-track') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    event.target.scrollBy({left:event.target.clientWidth * (event.key === 'ArrowRight' ? 1 : -1),behavior:reduced() ? 'instant' : 'smooth'});
  });
  let observer;
  const galleryColors = new WeakMap();
  const syncPurchase = () => {
    document.querySelectorAll('.cm-gallery').forEach(gallery => {
      const previous = galleryColors.get(gallery);
      if (previous !== undefined && previous !== gallery.dataset.color) {
        const track = gallery.querySelector('.cm-gallery-track');
        const slides = [...track.querySelectorAll('.cm-slide')];
        const index = Math.max(0, slides.findIndex(slide => slide.dataset.mediaId === gallery.dataset.featuredMedia));
        track.scrollTo({left:index * track.clientWidth,behavior:'instant'});
        gallery.querySelector('.cm-gallery-tabs').scrollLeft = 0;
      }
      galleryColors.set(gallery,gallery.dataset.color);
    });
    const primary = document.querySelector('.cm-product .add-to-cart-button');
    document.querySelectorAll('.cm-repeat-purchase').forEach(repeat => {
      repeat.hidden = !primary;
      if (!primary) return;
      const buy = repeat.querySelector('[data-cm-buy]');
      buy.disabled = primary.disabled;
      buy.textContent = primary.disabled ? primary.textContent.trim() : 'Add to cart';
      repeat.querySelector('.cm-repeat-color').textContent = document.querySelector('.cm-gallery')?.dataset.color || '';
      const price = document.querySelector('.cm-product product-price .price');
      repeat.querySelector('.cm-repeat-price').textContent = price?.textContent.trim() || '';
      const gallery = document.querySelector('.cm-gallery');
      const slides = [...(gallery?.querySelectorAll('.cm-slide') || [])];
      const image = (slides.find(slide => slide.dataset.mediaId === gallery.dataset.featuredMedia) || slides[0])?.querySelector('img');
      const destination = repeat.querySelector('.cm-repeat-image');
      if (image && destination.dataset.src !== image.src) {
        const clone = image.cloneNode();
        clone.loading = 'lazy'; clone.setAttribute('fetchpriority','low'); clone.sizes = '80px';
        destination.replaceChildren(clone); destination.dataset.src = image.src;
      }
    });
  };
  const watchPurchase = () => {
    observer?.disconnect();
    const primary = document.querySelector('.cm-product');
    if (primary) {
      observer = new MutationObserver(syncPurchase);
      observer.observe(primary,{subtree:true,childList:true,attributes:true,characterData:true});
    }
    syncPurchase();
  };
  watchPurchase();
  document.addEventListener('shopify:section:load', watchPurchase);
})();
